import { render, staticRenderFns } from "./notifications_list.vue?vue&type=template&id=fe0e1e46&scoped=true&"
import script from "./notifications_list.vue?vue&type=script&lang=js&"
export * from "./notifications_list.vue?vue&type=script&lang=js&"
import style0 from "./notifications_list.vue?vue&type=style&index=0&id=fe0e1e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0e1e46",
  null
  
)

export default component.exports